export default __webpack_public_path__ + "static/baronprosimir-833dbfc2f0bb60fc202ffd43779faaaf.png";